import { StateSummary } from '../classes/address';
import { AceLoader } from './ace-loader';
import AddressApi from './address-api';

export class AddressModal {
    modalElement: HTMLElement;
    loader: AceLoader;
    guestNameRequired: boolean;
    invalidFields: Array<string>;
    validationSummary: HTMLElement;

    constructor(modalElement: HTMLElement, container?: HTMLElement) {
        this.modalElement = modalElement;
        this.loader = new AceLoader();

        let addressForms = [].slice.call(modalElement.querySelectorAll('[data-address-form]'));

        addressForms.forEach(form => {
            form.addEventListener('submit', this.saveAddressForm);
        });

        let guestNameRequired = (<HTMLInputElement>this.modalElement.querySelector('[name="guestNameRequired"]'))
        if (guestNameRequired)
            this.guestNameRequired = guestNameRequired.value.toLowerCase() === 'true'

        this.validationSummary = (<HTMLElement>this.modalElement.querySelector('.validation-summary-errors'));
    }

    saveAddressForm = (e: Event) => {
        e.preventDefault();
        const thisForm = e.target as HTMLFormElement;
        this.resetValidationSummary();
        const validName = this.validateName();
        if (this.validateAddress() && validName) {
            const firstName = (<HTMLInputElement>thisForm.querySelector('[name="firstName"]'))?.value;
            const lastName = (<HTMLInputElement>thisForm.querySelector('[name="lastName"]'))?.value;
            const id = (<HTMLInputElement>thisForm.querySelector('[name="id"]')).value;
            const isPrimaryElement = thisForm.querySelector('[name="isPrimary"]') as HTMLInputElement;
            const isPrimary = isPrimaryElement?.checked;
            const address1 = (<HTMLInputElement>thisForm.querySelector('[name="address1"]')).value;
            const address2 = (<HTMLInputElement>thisForm.querySelector('[name="address2"]')).value;
            const city = (<HTMLInputElement>thisForm.querySelector('[name="city"]')).value;
            const state = (<HTMLSelectElement>thisForm.querySelector('[name="state')).value;
            const zipcode = (<HTMLInputElement>thisForm.querySelector('[name="zipCode"]')).value;
            const country = (<HTMLSelectElement>thisForm.querySelector('[name="country"]')).value;

            const phoneLabel = (<HTMLSelectElement>thisForm.querySelector('[name="phone"]'));
            const phoneIsmobileInput = (<HTMLSelectElement>thisForm.querySelector('[name="phone_ismobile"]'));
            const phoneIsTelemarketingAllowedInput = (<HTMLSelectElement>thisForm.querySelector('[name="phone_istelemarketing_allowed"]'));
            const phonePurposeElements = thisForm.querySelectorAll('[name="phone_purposes"]:checked');
            const phonePurposes = Array.from(phonePurposeElements).map((element: HTMLInputElement) => element.value);

            const phoneIsmobile: boolean = phoneIsmobileInput ? phoneIsmobileInput.value === 'true' : false;
            const phoneIsTelemarketingAllowed: boolean = phoneIsTelemarketingAllowedInput ? phoneIsTelemarketingAllowedInput.value === 'true' : false;

            const purposeElements = thisForm.querySelectorAll('[name="purpose"]:checked');
            const purposes = Array.from(purposeElements).map((element: HTMLInputElement) => element.value);

            const phone = phoneLabel ? phoneLabel.value : "";

            this.loader.show();
            return AddressApi.updateAddress(+id, address1, address2,
                city, +state, zipcode, +country, phone, isPrimary, firstName, lastName,
                purposes.join(','),
                phoneIsmobile, phoneIsTelemarketingAllowed, phonePurposes.join(',')).then(() => {
                    window.location.href = window.location.href;
                });
        }
        else {
            this.displayValidationSummary();
        }
    };

    validateName = () => {
        if (!this.guestNameRequired)
            return true;

        let firstName = (<HTMLInputElement>this.modalElement.querySelector('[name="firstName"]'));
        let lastName = (<HTMLInputElement>this.modalElement.querySelector('[name="lastName"]'));

        let firstNameValid = this.validateField(firstName);
        let lastNameValid = this.validateField(lastName);

        return firstNameValid && lastNameValid;
    }

    validateAddress = () => {
        let address1 = (<HTMLInputElement>this.modalElement.querySelector('[name="address1"]'));
        let city = (<HTMLInputElement>this.modalElement.querySelector('[name="city"]'));
        let state = (<HTMLSelectElement>this.modalElement.querySelector('[name="state"]'));
        let zipcode = (<HTMLInputElement>this.modalElement.querySelector('[name="zipCode"]'));
        let country = (<HTMLSelectElement>this.modalElement.querySelector('[name="country"]'));

        let address1valid = this.validateField(address1);
        let cityValid = this.validateField(city);
        let stateValid = state.disabled || this.validateField(state);
        let countryValid = this.validateField(country);

        return address1valid && cityValid && stateValid && countryValid;
    }

    validateField = (element: HTMLElement) => {
        if (!element)
            return false;
        let input = element as HTMLInputElement;
        let select = element as HTMLSelectElement;

        if ((input && (!input.value || !input.value.length)) ||
            (select && (!select.value || !select.value.length))) {
            let ename = element.attributes['name'].value;
            let label = this.modalElement.querySelector(`[for=${ename}]`);
            if (label) {
                this.invalidFields.push(label.innerHTML);
            } else {
                this.invalidFields.push(ename);
            }
            return false;
        }
        return true;
    }

    resetValidationSummary = () => {
        if (this.validationSummary) {
            this.validationSummary.innerHTML = "";
            this.validationSummary.setAttribute('hidden', '');
        }
        this.invalidFields = [];
    }

    displayValidationSummary = () => {
        let validationMessage = "The following fields are required: ";
        validationMessage += this.invalidFields.join(', ');
        if (this.validationSummary) {
            this.validationSummary.innerHTML = validationMessage;
            this.validationSummary.removeAttribute('hidden');
        }
    }
}